import { WebMixerService } from '@linktivity/triplabo-taxfree';
import { config as env } from '@triplabo/web/utils/env';
import {
  apiTokens,
  AUTH_HEADER,
  langMiddleware,
  sessionTokens,
  type TokenStore
} from './auth';

const createConfig = (tokens: TokenStore) => {
  const replay = (url: string, init: RequestInit) => {
    const headers = new Headers(init.headers);
    headers.set(AUTH_HEADER, tokens.getAccessToken());

    return fetch(url, { ...init, headers });
  };

  return new WebMixerService.Configuration({
    basePath: env.apiBase,
    apiKey: tokens.getAccessToken,
    middleware: [
      langMiddleware,
      {
        post: async ({ url, init, response }) => {
          if (response.status !== 401) {
            return;
          }

          const sentToken = new Headers(init.headers).get(AUTH_HEADER);
          const currentToken = tokens.getAccessToken();

          const refreshedByOther =
            sentToken && currentToken && sentToken !== currentToken;

          if (refreshedByOther) {
            return replay(url, init);
          }

          const refreshed = await tokens.refreshAccessToken();

          if (!refreshed) {
            return;
          }

          return replay(url, init);
        }
      }
    ]
  });
};

export const sessionConfig = createConfig(sessionTokens);

const config = createConfig(apiTokens);

export default config;
